import { HttpGetBuyerList, HttpGetBuyerLabelById } from "@/service/purchase/purchase";
export default {
    data () {
        return {
            buyerList: [],
            buyerLabel: '--'
        }
    },
    async created () {
        await HttpGetBuyerList().then(res => {
            this.buyerList = res.data.map(item => {
                return {
                    value: item.id,
                    label: item.name
                }
            });
        }, err => {
            this.$VMessage.error(err.message);
        })
    },
    computed: {
        getBuyType () {
            return this.buyerList
        },
        // getBuyTypeLabel () {}
    },
    methods: {
        getBuyTypeLabel (id) {
            let label = '--';
            if (!id) return label;
            HttpGetBuyerLabelById({
                id: id
            }).then(res => {
                this.buyerLabel = res.data.name;
            }, err => {
                this.$VMessage.error(err.message);
            })
        },
    }
}